import { FaArrowUp, FaArrowDown } from 'react-icons/fa';

function NumberOfDonationSort({ handleSortDonations, sortDirection , type}) {
    return (
        <div className='d-flex align-items-center'>
            <div>
            <label>
                {type==='time' ?  ("Time") : type=="compensation" ? ("Compensation") :  type ==="Number of Projects" ?  (type) : ("# Of Donations")  }
            </label>
            </div>
            <div>
                <span style={{ cursor: 'pointer'  }}>
                    <FaArrowUp
                        onClick={() => handleSortDonations('ASC')}
                        style={{
                            marginRight: '5px',
                            color: sortDirection === 'ASC' ? 'black' : 'black' // Change color based on sortDirection
                        }}
                    />
                    <FaArrowDown
                        onClick={() => handleSortDonations('DESC')}
                        style={{
                            color: sortDirection === 'DESC' ? 'black' : 'grey' // Change color based on sortDirection
                        }}
                    />
                </span>
            </div>
        </div>
    );
}

export default NumberOfDonationSort;
